import { render, staticRenderFns } from "./OfficialTitles.vue?vue&type=template&id=61f4c6d6"
import script from "./OfficialTitles.vue?vue&type=script&lang=js"
export * from "./OfficialTitles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports